export const AUTOMATION_IDS = {
  STAGE_SIDE_AREA: 'stage-side-area',
  STAGE_SIDE_AREA_BORDER: 'stage-side-area-border',
};
